/* Pura Vida No. 1 – Landingpage (sections/pv1-pura-vida.liquid) · Stand 09.10.2026
   Daten (Preise, Varianten, Abo-Pläne) kommen aus #pv1-data, gerendert von Liquid.
   Texte, die das Skript schreibt, gibt es auf Deutsch und Englisch (Weglot übersetzt sie nicht). */
(function () {
  'use strict';
  var root = document.getElementById('pv1');
  if (!root || root.getAttribute('data-pv1-init')) return;
  root.setAttribute('data-pv1-init', '1');

  var D = {};
  try { D = JSON.parse(document.getElementById('pv1-data').textContent); } catch (e) { D = {}; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var langMatch = /^\/(en|da|zh(?:-[a-z]+)?)(\/|$)/i.exec(location.pathname);
  var EN = !!langMatch || /^(en|da|zh)/i.test(document.documentElement.getAttribute('lang') || '');
  var LANG_PREFIX = langMatch ? '/' + langMatch[1] : '';
  var LOCALE = EN ? 'en-GB' : 'de-DE';
  var CUR = D.cur || 'EUR';
  var money = function (cents) {
    try { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CUR }).format((cents || 0) / 100); }
    catch (e) { return ((cents || 0) / 100).toFixed(2) + ' ' + CUR; }
  };
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };

  var T = EN ? {
    day: 'day', days: 'days', today: 'today', wk: 'wk', delivery: '≈ delivery',
    assume: {
      va: 'We assume about 9 g per cup (bean-to-cup machine, medium to strong).',
      sieb: 'We assume 19 g per cup, one espresso from our recipe.',
      kanne: 'We assume about 16 g per pot (3-cup moka pot). Count pots instead of cups.',
      fp: 'We assume 15 g per 250 ml cup.',
      filter: 'We assume 15 g per 250 ml cup.'
    },
    ebbe: function (d) { return 'Low tide from day ' + d + ': your tin runs empty before the next delivery. Pick a shorter rhythm or more coffee per delivery.'; },
    flutCalm: 'High tide: even every 4 weeks, coffee piles up. You’re more relaxed without a subscription.',
    flut: 'High tide: coffee slowly piles up. Skip a delivery now and then and you’re fine.',
    ok: 'Spot on: your tin never runs dry and nothing piles up.',
    meta: function (q, w, unit) { return 'per delivery · ' + q + ' kg every ' + w + ' weeks · unit price ' + unit + '/kg'; },
    save: function (m) { return 'save ' + m; }, same: 'same price as single bags',
    na: 'Currently unavailable', adding: 'Adding …',
    lines: {
      bean: ['Pura vida!', 'Psst. Just chilling.', 'Five more minutes …', 'Sunglasses stay on.', 'Coffee? Always.'],
      board: ['The board? Belongs to Endless Summer.', 'He’s still out on the water.', 'Later. Coffee first.'],
      crab: ['Pura vida!', 'Sideways is forwards too.', 'Back in a sec!', 'Crab tip: let the grinder run first.']
    }
  } : {
    day: 'Tag', days: 'Tage', today: 'heute', wk: 'Wo.', delivery: '≈ Lieferung',
    assume: {
      va: 'Wir rechnen mit ca. 9 g pro Tasse (Vollautomat, Stärke mittel bis stark).',
      sieb: 'Wir rechnen mit 19 g pro Tasse, also einem Espresso nach unserem Rezept.',
      kanne: 'Wir rechnen mit ca. 16 g pro Kanne (3-Tassen-Kanne). Zähl hier Kannen statt Tassen.',
      fp: 'Wir rechnen mit 15 g pro Tasse à 250 ml.',
      filter: 'Wir rechnen mit 15 g pro Tasse à 250 ml.'
    },
    ebbe: function (d) { return 'Ebbe ab Tag ' + d + ': Bis zur nächsten Lieferung ist die Dose leer. Nimm einen kürzeren Rhythmus oder mehr Kaffee pro Lieferung.'; },
    flutCalm: 'Flut: Selbst im 4-Wochen-Rhythmus sammelt sich Kaffee an. Ohne Abo bist du entspannter.',
    flut: 'Flut: Es sammelt sich langsam Kaffee an. Überspring ab und zu eine Lieferung, dann passt’s.',
    ok: 'Passt: Die Dose wird nicht leer, und es stapelt sich nichts.',
    meta: function (q, w, unit) { return 'pro Lieferung · ' + q + ' kg alle ' + w + ' Wochen · Grundpreis ' + unit + '/kg'; },
    save: function (m) { return 'spart ' + m; }, same: 'gleicher Preis wie einzeln',
    na: 'Gerade nicht verfügbar', adding: 'Kommt in den Warenkorb …',
    lines: {
      bean: ['Pura vida!', 'Psst. Ich chill hier nur.', 'Noch fünf Minuten …', 'Sonnenbrille bleibt auf.', 'Kaffee? Immer.'],
      board: ['Das Board? Gehört Endless Summer.', 'Der ist noch draußen.', 'Später. Erst Kaffee.'],
      crab: ['Pura vida!', 'Seitwärts ist auch vorwärts.', 'Bin gleich zurück!', 'Krebs-Tipp: Mahlwerk erst laufen lassen.']
    }
  };

  /* ---------- Hero: Szene platzieren, Sonnenuntergang beim Scrollen ---------- */
  var hero = $('#pv1-hero'), scene = $('#pv1-scene');
  var IW = 5052, IH = 7143, HORIZON = 0.5352;
  var topSet = false;
  function setTop() {
    var sy = window.scrollY || window.pageYOffset || 0;
    if (topSet && sy > 50) return;
    var t = Math.max(0, Math.round(hero.getBoundingClientRect().top + sy));
    hero.style.setProperty('--pv1-top', t + 'px'); topSet = true;
  }
  function layout() {
    if (window.getComputedStyle(scene).position !== 'absolute') return;
    var W = hero.clientWidth, H = Math.min(hero.clientHeight, 1200), sw, sh, sx, sy;
    if (!W || !H) return;
    if (W < 720) {
      sh = Math.max(0.68 * H / HORIZON, W * IH / IW); sw = sh * IW / IH;
      if (sw < W) { sw = W; sh = sw * IH / IW; }
      sx = Math.min(0, Math.max(W - sw, W / 2 - 0.56 * sw)); sy = 0;
    } else {
      sw = Math.max(W, H * IW / IH); sh = sw * IH / IW;
      sx = (W - sw) / 2;
      sy = Math.min(0, Math.max(H - sh, 0.66 * H - HORIZON * sh));
    }
    scene.style.width = sw + 'px'; scene.style.height = sh + 'px';
    scene.style.transform = 'translate(' + sx + 'px,' + sy + 'px)';
    hero.style.setProperty('--k', (sw / IW).toFixed(5));
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (!reduce) {
        var r = hero.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, -r.top / (r.height * 0.8)));
        hero.style.setProperty('--p', p.toFixed(3));
      }
      updatePill();
    });
  }
  (function stars() {
    var box = $('#pv1-stars'), html = '';
    for (var i = 0; i < 46; i++) {
      var x = (Math.random() * 96 + 2).toFixed(2), y = (Math.random() * 92 + 2).toFixed(2), s = (Math.random() * 18 + 8).toFixed(1);
      html += '<span class="pv1-star" style="left:' + x + '%;top:' + y + '%;width:calc(var(--k)*' + s + 'px);height:calc(var(--k)*' + s + 'px);animation-delay:' + (Math.random() * 3).toFixed(2) + 's"></span>';
    }
    if (box) box.innerHTML = html;
    var night = $('#pv1-night'), h2 = '';
    for (var j = 0; j < 60; j++) {
      var nx = (Math.random() * 98 + 1).toFixed(2), ny = (Math.random() * 70 + 1).toFixed(2), ns = (Math.random() * 1.6 + 1).toFixed(1);
      h2 += '<span class="pv1-star" style="left:' + nx + '%;top:' + ny + '%;width:' + ns + 'px;height:' + ns + 'px;animation-delay:' + (Math.random() * 3).toFixed(2) + 's"></span>';
    }
    if (night) night.innerHTML = h2;
  })();

  // Sprechblasen
  var lineIdx = { bean: 0, board: 0, crab: 0 }, bubbleTimers = {};
  function say(who) {
    var el = $('#pv1-bubble-' + who); if (!el) return;
    var lines = T.lines[who];
    el.textContent = lines[lineIdx[who] % lines.length]; lineIdx[who]++;
    el.style.setProperty('--dx', '0px');
    var hr = hero.getBoundingClientRect(), br = el.getBoundingClientRect(), w = br.width;
    var cx = br.left + w / 2, dx = 0, pad = 10;
    if (cx - w / 2 < hr.left + pad) dx = hr.left + pad - (cx - w / 2);
    if (cx + w / 2 > hr.right - pad) dx = (hr.right - pad) - (cx + w / 2);
    el.style.setProperty('--dx', Math.round(dx) + 'px');
    el.classList.add('is-on'); clearTimeout(bubbleTimers[who]);
    bubbleTimers[who] = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }
  $$('.pv1-hot').forEach(function (b) {
    b.addEventListener('click', function () {
      var who = b.getAttribute('data-bubble'); say(who);
      if (who === 'crab' && !reduce) { b.classList.remove('is-running'); void b.offsetWidth; b.classList.add('is-running'); }
    });
  });
  var crabBtn = $('#pv1-crab');
  if (crabBtn) crabBtn.addEventListener('animationend', function () { crabBtn.classList.remove('is-running'); }, true);
  var sticker = $('#pv1-sticker');
  if (sticker) {
    sticker.addEventListener('click', function () { if (reduce) return; sticker.classList.remove('is-spin'); void sticker.offsetWidth; sticker.classList.add('is-spin'); });
    sticker.addEventListener('animationend', function () { sticker.classList.remove('is-spin'); });
  }

  /* ---------- Sprachkurs ---------- */
  var chips = $$('#pv1-sprache .pv1-chip'), answer = $('#pv1-answer');
  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      var k = c.getAttribute('data-say');
      chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
      $$('[data-ans]', answer).forEach(function (a) { a.hidden = a.getAttribute('data-ans') !== k; });
      answer.classList.remove('is-pop'); void answer.offsetWidth; answer.classList.add('is-pop');
    });
  });

  /* ---------- Hüttenküche ---------- */
  var DEV_DEFAULT_DRINK = { va: 'va-esp', sieb: 'sieb-esp', kanne: 'kanne-pur', fp: 'fp-pur', filter: 'filter-pur' };
  var devBtns = $$('.pv1-dev'), drinkBtns = $$('#pv1-drinks .pv1-chip'), recipes = $$('.pv1-recipe');
  var aboForm = $('#pv1-panel-abo');
  var state = { dev: 'va', cups: 3, touched: false, pgrind: 'wb' };
  function showRecipe(id) {
    drinkBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-drink') === id ? 'true' : 'false'); });
    recipes.forEach(function (r) { r.hidden = r.getAttribute('data-recipe') !== id; });
  }
  function checkGrind(k) {
    var gi = $('#pv1-g-' + k);
    if (gi && !gi.disabled) { gi.checked = true; return; }
    var first = $$('input[name="id"]', aboForm).filter(function (i) { return !i.disabled; })[0];
    if (first) first.checked = true;
  }
  function setDevice(dev) {
    if (!DEV_DEFAULT_DRINK[dev]) dev = 'va';
    state.dev = dev;
    devBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-dev') === dev ? 'true' : 'false'); });
    drinkBtns.forEach(function (b) { b.hidden = b.getAttribute('data-for') !== dev; });
    showRecipe(DEV_DEFAULT_DRINK[dev]);
    var sel = $('#pv1-calc-dev'); if (sel && sel.value !== dev) sel.value = dev;
    var g = dev === 'kanne' ? 'bl' : 'wb';
    checkGrind(g);
    state.pgrind = g; var pgi = $('#pv1-pg-' + g); if (pgi) pgi.checked = true;
    store.set('pv1-dev', dev);
    state.touched = false;
    recalc();
  }
  devBtns.forEach(function (b) { b.addEventListener('click', function () { setDevice(b.getAttribute('data-dev')); }); });
  drinkBtns.forEach(function (b) { b.addEventListener('click', function () { showRecipe(b.getAttribute('data-drink')); }); });

  /* ---------- Gezeitenrechner ---------- */
  var GPC = { va: 9, sieb: 19, kanne: 16, fp: 15, filter: 15 };
  function availableWeeks() {
    return $$('input[name="selling_plan"]', aboForm).map(function (i) { return +i.getAttribute('data-w'); });
  }
  function suggest(D_days) {
    var weeks = availableWeeks();
    if (!weeks.length) return {};
    var maxW = Math.max.apply(null, weeks) * 7;
    if (D_days > maxW + 14) return { calm: true };
    var best = null;
    [1, 2, 3].forEach(function (q) {
      weeks.map(function (w) { return w * 7; }).forEach(function (w) {
        var slack = q * D_days - w; if (slack < 0) return;
        if (!best || slack < best.slack - 0.01 || (Math.abs(slack - best.slack) < 0.01 && w > best.w)) best = { q: q, w: w, slack: slack };
      });
    });
    return best || { b2b: true };
  }
  function simulate(gPerDay, wDays, qty, days) {
    var pts = [], level = qty * 1000, t, firstEmpty = null;
    pts.push([0, level]);
    for (t = 1; t <= days; t++) {
      var prev = level; level = Math.max(0, level - gPerDay);
      if (prev > 0 && level === 0 && firstEmpty === null) { firstEmpty = t - 1 + prev / gPerDay; pts.push([firstEmpty, 0]); }
      pts.push([t, level]);
      if (t % wDays === 0 && t < days) { level += qty * 1000; pts.push([t, level]); }
    }
    return { pts: pts, end: level, firstEmpty: firstEmpty };
  }
  var lastSim = null;
  function drawChart(sim, wDays) {
    lastSim = [sim, wDays];
    var box = $('#pv1-chart'); if (!box) return;
    var Wd = Math.max(300, Math.round(box.clientWidth || 600)), Hd = Wd < 480 ? 210 : 240, L = 50, R = 12, T0 = 16, B = 32, days = 56;
    var narrow = Wd < 480;
    var maxY = 0; sim.pts.forEach(function (p) { if (p[1] > maxY) maxY = p[1]; });
    var step = maxY > 3000 ? 1000 : 500; maxY = Math.max(step * 2, Math.ceil(maxY * 1.08 / step) * step);
    var x = function (d) { return L + d / days * (Wd - L - R); }, y = function (g) { return T0 + (1 - g / maxY) * (Hd - T0 - B); };
    var s = '<svg viewBox="0 0 ' + Wd + ' ' + Hd + '" width="' + Wd + '" height="' + Hd + '" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">';
    s += '<defs><linearGradient id="pv1-sea" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8FC8FF" stop-opacity=".75"/><stop offset="1" stop-color="#2F73A6" stop-opacity=".25"/></linearGradient></defs>';
    for (var g = 0; g <= maxY; g += step) {
      s += '<line x1="' + L + '" x2="' + (Wd - R) + '" y1="' + y(g) + '" y2="' + y(g) + '" stroke="#FFF4E6" stroke-opacity="' + (g === 0 ? .55 : .14) + '" stroke-width="1"/>';
      s += '<text x="' + (L - 8) + '" y="' + (y(g) + 4) + '" fill="#E6DCF3" font-size="12" text-anchor="end" font-family="Jost, sans-serif">' + (g === 0 ? '0' : (g >= 1000 ? (g / 1000).toString().replace('.', EN ? '.' : ',') + ' kg' : g + ' g')) + '</text>';
    }
    for (var wk = 0; wk <= 8; wk += (narrow ? 2 : 1)) {
      s += '<text x="' + x(wk * 7) + '" y="' + (Hd - 10) + '" fill="#E6DCF3" font-size="12" text-anchor="' + (wk === 0 ? 'start' : (wk === 8 ? 'end' : 'middle')) + '" font-family="Jost, sans-serif">' + (wk === 0 ? T.today : wk + ' ' + T.wk) + '</text>';
    }
    var d = 'M' + x(0) + ' ' + y(0);
    sim.pts.forEach(function (p) { d += ' L' + x(p[0]).toFixed(1) + ' ' + y(p[1]).toFixed(1); });
    d += ' L' + x(days) + ' ' + y(0) + ' Z';
    s += '<path d="' + d + '" fill="url(#pv1-sea)"/>';
    var l = ''; sim.pts.forEach(function (p, i) { l += (i ? ' L' : 'M') + x(p[0]).toFixed(1) + ' ' + y(p[1]).toFixed(1); });
    s += '<path d="' + l + '" fill="none" stroke="#FFF4E6" stroke-width="2.4" stroke-linejoin="round"/>';
    for (var i = 1; i < sim.pts.length; i++) {
      var a = sim.pts[i - 1], b = sim.pts[i];
      if (a[1] === 0 && b[1] === 0 && b[0] > a[0]) s += '<line x1="' + x(a[0]) + '" x2="' + x(b[0]) + '" y1="' + y(0) + '" y2="' + y(0) + '" stroke="#FF8A7A" stroke-width="5" stroke-linecap="round"/>';
    }
    for (var t = 0; t < days; t += wDays) {
      s += '<g transform="translate(' + x(t) + ',' + (T0 + 2) + ')"><path d="M-7 4 q3.5 -5 7 0 t7 0" fill="none" stroke="#FFC27C" stroke-width="2.2" stroke-linecap="round"/></g>';
    }
    s += '<text x="' + (Wd - R) + '" y="' + (T0 + 8) + '" fill="#FFC27C" font-size="12" text-anchor="end" font-family="Jost, sans-serif">' + T.delivery + '</text>';
    s += '</svg>';
    box.innerHTML = s;
  }
  function checked(name, ctx) { return $('input[name="' + name + '"]:checked', ctx || aboForm); }
  function setChecked(name, attr, val) {
    var el = $$('input[name="' + name + '"]', aboForm).filter(function (i) { return i.getAttribute(attr) === String(val); })[0];
    if (el && !el.disabled) el.checked = true;
  }
  function recalc() {
    var gDay = state.cups * GPC[state.dev], D_days = 1000 / gDay;
    $('#pv1-assume').textContent = T.assume[state.dev];
    var nd = Math.round(D_days);
    $('#pv1-days').textContent = nd + ' ' + (nd === 1 ? T.day : T.days);
    var sug = suggest(D_days);
    $('#pv1-calm').hidden = !sug.calm;
    $('#pv1-b2b').hidden = !sug.b2b;
    $$('[data-rec]').forEach(function (e) { e.hidden = true; });
    if (!state.touched) {
      if (sug.w) { setChecked('selling_plan', 'data-w', sug.w / 7); setChecked('quantity', 'value', sug.q); }
      else if (sug.calm) { var ws = availableWeeks(); setChecked('selling_plan', 'data-w', Math.max.apply(null, ws)); setChecked('quantity', 'value', 1); }
      else if (sug.b2b) { var ws2 = availableWeeks(); setChecked('selling_plan', 'data-w', Math.min.apply(null, ws2)); setChecked('quantity', 'value', 3); }
    }
    if (sug.w) { var rec = $('[data-rec="' + (sug.w / 7) + '"]'); if (rec) rec.hidden = false; }
    var rIn = checked('selling_plan'), qIn = checked('quantity');
    var rhythm = rIn ? +rIn.getAttribute('data-w') : 4, qty = qIn ? +qIn.value : 1;
    var sim = simulate(gDay, rhythm * 7, qty, 56);
    drawChart(sim, rhythm * 7);
    var st = $('#pv1-status'), tx = $('#pv1-status-t');
    if (sim.firstEmpty !== null) { st.setAttribute('data-kind', 'ebbe'); tx.textContent = T.ebbe(Math.ceil(sim.firstEmpty)); }
    else if (sim.end > qty * 1000 + 400) { st.setAttribute('data-kind', 'flut'); tx.textContent = sug.calm ? T.flutCalm : T.flut; }
    else { st.setAttribute('data-kind', 'ok'); tx.textContent = T.ok; }
    $('#pv1-cups').textContent = state.cups;
    var gIn = checked('id');
    $('#pv1-grind-warn').hidden = !(state.dev === 'va' && gIn && gIn.getAttribute('data-k') !== 'wb');
    renderPrices();
  }
  $('#pv1-calc-dev').addEventListener('change', function (e) { setDevice(e.target.value); });
  $('#pv1-cups-minus').addEventListener('click', function () { if (state.cups > 1) { state.cups--; state.touched = false; recalc(); } });
  $('#pv1-cups-plus').addEventListener('click', function () { if (state.cups < 20) { state.cups++; state.touched = false; recalc(); } });
  $$('input[name="selling_plan"], input[name="quantity"]', aboForm).forEach(function (i) { i.addEventListener('change', function () { state.touched = true; recalc(); }); });
  $$('input[name="id"]', aboForm).forEach(function (i) { i.addEventListener('change', recalc); });
  $$('input[name="pv1-pgrind"]').forEach(function (i) { i.addEventListener('change', function () { state.pgrind = i.value; renderPrices(); }); });

  /* ---------- Preise ---------- */
  function renderPrices() {
    var gIn = checked('id'), rIn = checked('selling_plan'), qIn = checked('quantity');
    var k = gIn ? gIn.getAttribute('data-k') : 'wb';
    var v = (D.abo && D.abo[k]) || {};
    var w = rIn ? rIn.getAttribute('data-w') : '4';
    var planId = D.plans ? D.plans[w] : 0;
    var unit = (v.sp && planId && v.sp[planId]) || v.p || 0;
    var qty = qIn ? +qIn.value : 1;
    $('#pv1-sum-price').textContent = money(unit * qty);
    $('#pv1-sum-meta').textContent = T.meta(qty, w, money(unit));
    var sub = $('#pv1-sub'), ok = !!(v.a && v.id && planId);
    sub.disabled = !ok;
    if (!sub.getAttribute('data-label')) sub.setAttribute('data-label', sub.textContent);
    sub.textContent = ok ? sub.getAttribute('data-label') : T.na;

    var pk = state.pgrind, single = (D.single && D.single[pk]) || 0;
    $$('form[data-pre]').forEach(function (f) {
      var key = f.getAttribute('data-pre'), n = key === 'm6' ? 6 : 12;
      var pv = (D[key] && D[key][pk]) || {};
      var idIn = $('[data-pre-id]', f); if (idIn && pv.id) idIn.value = pv.id;
      var btn = $('button[type="submit"]', f), can = !!(pv.a && pv.id && D[key].plan);
      if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
      btn.disabled = !can; btn.textContent = can ? btn.getAttribute('data-label') : T.na;
      var pr = pv.p || 0, n6 = n === 6 ? '6' : '12';
      var pEl = $('#pv1-p' + n6), kgEl = $('#pv1-p' + n6 + '-kg'), svEl = $('#pv1-p' + n6 + '-save');
      if (pEl) pEl.textContent = money(pr);
      if (kgEl) kgEl.textContent = n + ' × 1 kg · ' + money(Math.round(pr / n)) + '/kg';
      if (svEl) { var save = single * n - pr; svEl.textContent = save > 0 ? T.save(money(save)) : T.same; }
    });
  }

  /* ---------- Warenkorb (Abo-Pläne immer mit selling_plan) ---------- */
  function addToCart(form, items) {
    var btn = $('button[type="submit"]', form);
    if (btn) { btn.disabled = true; btn.textContent = T.adding; }
    var url = (D.cartAdd || '/cart/add').replace(/\/$/, '') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () { window.location.href = LANG_PREFIX + (D.cartUrl || '/cart'); })
      .catch(function () { HTMLFormElement.prototype.submit.call(form); });
  }
  if (aboForm) aboForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var gIn = checked('id'), rIn = checked('selling_plan'), qIn = checked('quantity');
    if (!gIn || !rIn) return;
    addToCart(aboForm, [{ id: +gIn.value, quantity: qIn ? +qIn.value : 1, selling_plan: +rIn.value }]);
  });
  $$('form[data-pre]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var key = f.getAttribute('data-pre'), pv = (D[key] && D[key][state.pgrind]) || {};
      if (!pv.id || !D[key].plan) return;
      addToCart(f, [{ id: pv.id, quantity: 1, selling_plan: D[key].plan }]);
    });
  });

  // Tabs
  var tabs = [$('#pv1-tab-abo'), $('#pv1-tab-pre')], panels = [$('#pv1-panel-abo'), $('#pv1-panel-pre')];
  function selectTab(i) {
    tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; panels[j].hidden = i !== j; });
  }
  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { selectTab(i); });
    t.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { var n = (i + 1) % 2; selectTab(n); tabs[n].focus(); e.preventDefault(); } });
  });

  // Abo-Pille
  var pill = $('#pv1-pill'), aboSec = $('#pv1-abo'), sprache = $('#pv1-sprache');
  function updatePill() {
    if (!pill) return;
    var vh = window.innerHeight, a = aboSec.getBoundingClientRect(), s = sprache.getBoundingClientRect();
    pill.classList.toggle('is-on', s.top < vh * 0.4 && (a.top > vh * 0.9 || a.bottom < 0));
  }

  // Start
  setDevice(store.get('pv1-dev') || 'va');
  setTop(); layout(); onScroll();
  window.addEventListener('resize', function () { setTop(); layout(); onScroll(); if (lastSim) drawChart(lastSim[0], lastSim[1]); }, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.ResizeObserver) new ResizeObserver(layout).observe(hero);
  var bg = $('.pv1-bg'); if (bg && !bg.complete) bg.addEventListener('load', layout);
  var refit = function () { setTop(); layout(); onScroll(); };
  window.addEventListener('load', refit);
  setTimeout(refit, 1500);
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(refit);
    Array.prototype.forEach.call(document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .header-wrapper'), function (el) { ro.observe(el); });
  }
})();
